export default __webpack_public_path__ + "aab940aa36d3cd64ef3d22fbb7a1b7c8.png";